export default __webpack_public_path__ + "static/media/schultenumbers_preex.01f66a99.svg";